import { Component, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddEditCouponModalComponent } from "../add-edit-coupon-modal/add-edit-coupon-modal.component";
import { ProductService } from "src/app/core/services/product.service";

@Component({
  selector: "app-coupon-general",
  templateUrl: "./coupon-general.component.html",
  styleUrls: ["./coupon-general.component.scss"],
})
export class CouponGeneralComponent {
  @Input() couponList: any = [];
  @Input() currentCouponType: any;
  isLoading = false;
  pageSize = 10;
  pageNumber = 1;
  page_details: any = {
    count: 0,
    next: "",
    previous: "",
  };
  constructor(private modalService: NgbModal, private api: ProductService) {}

  ngOnInit() {
    this.getCouponList(this.currentCouponType, this.pageSize, 0);
  }

  openAddorEditModal(coupon?: any) {
    const modalRef = this.modalService.open(AddEditCouponModalComponent, {
      size: "lg",
      // keyboard: false,
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.couponType = "general";
    modalRef.componentInstance.couponData = coupon ? coupon : "";
    modalRef.componentInstance.couponId = coupon?.id;
    modalRef.result.then((res) => {
      if (res) {
        this.getCouponList(this.currentCouponType, this.pageSize, 0);
      }
    });
  }

  nextPage(page) {
    this.getCouponList(
      this.currentCouponType,
      this.pageSize,
      this.pageSize * (page - 1)
    );
  }

  getCouponList(type, limit, offset) {
    this.isLoading = true;
    this.api.getCoupon(type, limit, offset).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.couponList = res?.results;
        this.page_details.count = res?.count;
      },
      (error) => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }
}
